import { useEffect, useState } from 'react';
import { useAuth } from 'src/contexts/auth';
import api from 'src/services/api';

export type ConsumoSemanalItem = { dia: number; mes: number; ano: number; litros: number };

export type DashboardCombustivel = {
    abastecimentoHoje: { litros: number; litrosPorHora: number; percMudanca: number };
    veiculosHoje: { hoje: number; totalFrota: number };
    mesAtual: { litros: number; valor: number };
    alertas: { total: number; criticos: number };
    consumoSemanal: ConsumoSemanalItem[];
};

const empty: DashboardCombustivel = {
    abastecimentoHoje: { litros: 0, litrosPorHora: 0, percMudanca: 0 },
    veiculosHoje: { hoje: 0, totalFrota: 0 },
    mesAtual: { litros: 0, valor: 0 },
    alertas: { total: 0, criticos: 0 },
    consumoSemanal: [],
};

export const useDashboardCombustivel = () => {
    const { userAgencyId } = useAuth();
    const [data, setData] = useState<DashboardCombustivel>(empty);
    const [loading, setLoading] = useState(false);

    const fetch = () => {
        if (!userAgencyId) return;
        setLoading(true);
        api.get(`/dashboard-combustivel/${userAgencyId}`)
            .then(res => { setData(res.data); setLoading(false); 
                 console.log('DashboardCombustivelController.fetch response:', res.data);
            })
            .catch(err => { console.error(err); setLoading(false); });
           
    };

    useEffect(() => { fetch(); }, [userAgencyId]);

    return { data, loading, refetch: fetch };
};
